"use client";

import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { themes, type ThemeId } from "@/features/theme/themes";

type ThemeState = {
  theme: ThemeId;
  setTheme: (theme: ThemeId) => void;
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: "cybernetic-minimalism",
      setTheme: (theme) => {
        if (themes.includes(theme)) {
          set({ theme });
        }
      }
    }),
    {
      name: "stella-ui-theme",
      storage: createJSONStorage(() => localStorage)
    }
  )
);
